import {
    IIoCContainer
} from '@lmnop/web-core';
import { IAppSettings } from 'app-src';

import {
    CoreModulesIoC
} from './core-modules-ioc.class';


export interface IAppIoCContainer extends IIoCContainer {

    core: CoreModulesIoC;
    settings: IAppSettings;

}
